// @flow

import {observer} from 'mobx-react';
import React, { Component } from 'react';
import cx from 'classnames';
import Switch from 'react-switch';
import './ToggleSwitch.scss';

type Props = {
  value: boolean,
  setValue: Function,
  propertyName: string,
  disabled: ?boolean,
  onValue: ?any,
  offValue: ?any
}

@observer
class ToggleSwitch extends Component<Props> {

  handleChange = (checked: boolean) => {
    this.props.setValue(this.props.propertyName, checked);
  }

  render() {

    return (
      <div className={cx('toggle-switch', { toggled: this.props.value })}>
        {this.props.offValue && <span className="space-right" >{this.props.offValue}</span>}
        <Switch
          onChange={this.handleChange}
          checked={this.props.value}
          handleDiameter={10}
          height={18}
          width={32}
          offHandleColor="#323A45"
          onHandleColor="#005CE4"
          checkedIcon={false}
          uncheckedIcon={false}
          activeBoxShadow="0 0 1px 1px #0078ff"
          disabled={this.props.disabled}
        />
        {this.props.onValue && <span className="space-left" >{this.props.onValue}</span>}
      </div>
    );
  }
}

export default ToggleSwitch;
